<template>
  <fin-data-loader :resolver="fetchData" class="fin-screener-mask" fullpage>
    <template #loading_additional>
      <Portal to="breadcrumb_etfScreenerMask">
        Lade...
      </Portal>
    </template>
    <template #content>
      <!-- right side of the screener in edit mode -->
      <fin-screener-content :hasChanged="hasChanged"
                            :screener-type="'etfScreener'"
                            @applyTool="applyTool"
                            @reset="resetScreener"
                            v-if="selectedOption"
                            v-model="selectedOption"/>
    </template>
  </fin-data-loader>
</template>

<script>
import {finUserAPI} from '@/js/finAPI'
import FinScreenerContent from '@/components/pages/finTools/finScreener/screenerMask/content/index'
import {isEqual} from 'lodash-es'
import FinDataLoader from '@/components/common/DataLoader/index'

export default {
  name: 'fin-add-etf-screener',
  components: {
    FinDataLoader,
    FinScreenerContent
  },
  data() {
    return {
      originalModel: undefined,
      selectedOption: undefined,
      filterOptions: undefined,
      selectedItems: [],
      displayMode: 'selection'
    }
  },
  methods: {
    setNewModel(newVal) {
      console.log("setNewModel", newVal)
      // clone the parameter into selectedOption
      if (newVal) {
        const newModel = JSON.parse(JSON.stringify(newVal))
        // adapt assetClass in model in order to have the same data structure as for the share screener
        const assetClassId = newModel.assetClass
        newModel.assetClass = {
          id: assetClassId
        }
        if (newModel.rangeFilters.items.length > 1) {
          for (let i = newModel.rangeFilters.items.length - 1; i > 1; i--) {
            const itemid = newModel.rangeFilters.items[i].item.itemId
            if (i > newModel.rangeFilters.items.findIndex((item) => {
              return item.item.itemId === itemid
            })) {
              console.error('removed duplicate for ', i, itemid)
              newModel.rangeFilters.items.splice(i, 1)
            }
          }
        }
        if (newModel.valueFilters.items.length > 1) {
          for (let i = newModel.valueFilters.items.length - 1; i > 1; i--) {
            const itemid = newModel.valueFilters.items[i].item.itemId
            if (i > newModel.valueFilters.items.findIndex((item) => {
              return item.item.itemId === itemid
            })) {
              console.error('removed duplicate for ', i, itemid)
              newModel.valueFilters.items.splice(i, 1)
            }
          }
        }

        this.selectedOption = newModel
        console.log("setNewModel this.selectedOption", this.selectedOption)
      } else {
        this.$toasted.global.finToast({
          message: 'Dein Screener konnte nicht geladen werden.',
          type: 'error'
        })
      }
    },
    resetScreener() {
      this.setNewModel(this.originalModel)
    },
    // TODO maxValue needed?
    maxValue(item) {
      return Math.floor(this.capital / item.instrument.close)
    },
    applyTool() {
      this.$router.push({
        name: 'etfScreenerExecute',
        params: {id: this.$route.params.id}
      })
    },
    async fetchData() {
      console.log('fetchData this.selectedOption', this.selectedOption)
      this.filterOptions = []
      this.filterOptions.push(this.selectedOption)
      const userScreeners = await finUserAPI.getEtfScreeners()
      console.log('fetchData user etf screeners', userScreeners)
      userScreeners.forEach(item => {
        this.filterOptions.push(item)
      })
      console.log('fetchData this.filterOptions[0]:', this.filterOptions)
      this.originalModel = userScreeners.find(item => {
        return item.id === this.$route.params.id
      })
      console.log('fetchData this.originalModel', this.originalModel)
      this.setNewModel(this.originalModel)
    }
  },
  computed: {
    hasChanged() {
      // the selectedOption contains the asset class as object whereas the originalModel contains a string
      const selectedOptionCopy = JSON.parse(JSON.stringify(this.selectedOption))
      if (selectedOptionCopy.assetClass.id) {
        selectedOptionCopy.assetClass = selectedOptionCopy.assetClass.id
      }

      const result = isEqual(this.originalModel, selectedOptionCopy)
      return !result
    },
  }
}

</script>

<style lang="scss" scoped>

.fin-hasChanged {
  color: red;
  font-size: 20px;
  font-weight: bold;
  vertical-align: top;
}

::v-deep .v-select__selections {
  font-weight: bold
}

::v-deep .v-select__selections input {
  max-width: 10%
}

::v-deep .v-input__slot {
  box-shadow: none !important;
}

::v-deep .v-text-field > .v-input__control > .v-input__slot:after {
  border-style: none !important;
}

::v-deep .v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none !important;
}

::v-deep .fin-result-list-header .v-select__selection {
  color: $fin-color-primary-dark !important;
}

</style>
